/**
 * messageId → 時間戳 的去重表共用維護邏輯。
 *
 * 列印路徑上有三張這種表（收到時的 recentPushes、送出 ACK 的 deliveredMessages、
 * 通用的 processedMessages），維護規則一致，抽出來避免改一個漏一個。
 * native 端還有第四張（printLog.js 的 deliveredAt），那個分屬另一個 npm 套件、
 * 沒辦法直接 import，只能各寫一份。
 */

/**
 * 訊息表的筆數上限，避免尖峰無限成長
 */
export const MESSAGE_MAP_MAX_SIZE = 1000

/**
 * 清掉過期項目；仍超量時「淘汰最舊的」而不是整表清空。
 * 整表清空會把還在後端重送視窗內的紀錄一起刪掉，之後的重送就會變成重印。
 *
 * @param {Map<string, number>} map 要維護的表
 * @param {number} ttlMs 保留時間
 * @param {number} [now] 現在時間，測試用
 * @param {number} [maxSize] 筆數上限，不傳則用 MESSAGE_MAP_MAX_SIZE
 */
export const pruneMessageMap = (
	map,
	ttlMs,
	now = Date.now(),
	maxSize = MESSAGE_MAP_MAX_SIZE,
) => {
	for (const [id, timestamp] of map) {
		if (now - timestamp >= ttlMs) {
			map.delete(id)
		}
	}
	if (map.size > maxSize) {
		let excess = map.size - maxSize
		for (const id of map.keys()) {
			map.delete(id)
			if (--excess <= 0) {
				break
			}
		}
	}
}
